import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=79359b74"
import script from "./CustomerTable.vue?vue&type=script&lang=js"
export * from "./CustomerTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&id=79359b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports